/**
 * General scripts
 *
 * This file should contain any scripts needed. Instead of calling it in the header
 * or throwing it inside wp_head(), this file will be called automatically in the
 * footer for better performance.
 *
 * @package   seedyjoints
 * @since     JointsWP
 * @author    <corey@chatmandesign.com>
 * @link      http://chatmandesign.com
 */

(function($) {

	//! – FUNCTIONS

	function cd_responsive_scripts() {
		if (Foundation.MediaQuery.atLeast('medium')) {
			// load gravatars
			$('.comment img[data-gravatar]').each(function(){
				$(this).attr('src',$(this).attr('data-gravatar'));
			});
		}
	}

	//! – DOM READY

	$(function() {

		//! –– POLYFILLS & FALLBACKS

		/**
		 * Makes "skip to content" link work correctly in Chrome (and IE9) for better
		 * accessibility. From Twenty Fourteen.
		 *
		 * @link http://www.nczonline.net/blog/2013/01/15/fixing-skip-to-content-links/
		 */
		$(window).on( 'hashchange', function() {
			var element = document.getElementById( location.hash.substring( 1 ) );

			if ( element ) {
				if ( ! /^(?:a|select|input|button|textarea)$/i.test( element.tagName ) ) {
					element.tabIndex = -1;
				}

				element.focus();

				// Repositions the window on jump-to-anchor to account for header height.
				window.scrollBy( 0, -80 );
			}
		} );

		//! –– GENERAL SCRIPTS

		// Initialize Modal open and close events
		$('.modal-reveal').each(function(index) {
			let modalId = $(this).attr('modal-id');
			let overlayId = modalId + '-overlay';
			let modalIdJ = '#' + modalId;
			let overlayIdJ = '#' + overlayId;

			$(modalIdJ).appendTo('body');

			$.when($(modalIdJ).wrap('<div class="cd-modal-overlay" id="' + overlayId + '"></div>'))
				.then(() => {
					$(modalIdJ).css('display', 'block'); // display modal after wrap completes
				}
			);

			// Fade in modal
			$(this).on('click', () => {
				$(overlayIdJ).css('display', 'block');
				setTimeout(() => {
					$(overlayIdJ).addClass('fade');
				}, 1);
			});

			// Fade out Modal
			$(overlayIdJ).on('click', () => {
				$(overlayIdJ).removeClass('fade');
				setTimeout(() => {
					$(overlayIdJ).css('display', 'none');
				}, 300); // 300ms for fade-out
			});
		});

		// Calculate and Display Estimate
		$('.wp-block-cd-zwaska-estimator .radio-group, .wp-block-cd-zwaska-estimator .total-words').on('change', function() {
			const blockClass = '.wp-block-cd-zwaska-estimator';
			let totalWords = $(blockClass + ' .total-words').val();
			let cost = $(blockClass + ' input[name="cost"]:checked').val();
			$(blockClass + ' .estimate').text((totalWords * cost).toFixed(2));
		});

		// Load Foundation
		$(document).foundation();

		// Setup responsive scripts
		$(window).on('changed.zf.mediaquery', () => cd_responsive_scripts());
		cd_responsive_scripts();

	}); // jQuery document ready


	//! – ALL ASSETS LOADED

	/*
	$(window).on('load', function () {

	});
	*/
})(jQuery);
